import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import useHeaders from "../../helpers/useHeaders";
import Checkbox from "@mui/material/Checkbox";
import { visuallyHidden } from "@mui/utils";
import Tooltip from "@mui/material/Tooltip";
import useEncryption from "../../services/useEncryption";
import LocationTagModal from "./components/LocationTagModal";
import {
  resendInviteProviderApi,
  getProvidersApi,
  getWebhookUrl,
} from "../../api/adminApi/adminApi";
import useToast from "../../helpers/useToast";
import { useDispatch, useSelector } from "react-redux";
import { setLocationData } from "../../redux/slice/locSlice";
import { toast } from "react-toastify";
import WebHookModal from "./WebHookModal";
import { useNavigate, useOutletContext } from "react-router-dom";
import "../doctor/components/allpages.css";
import { selectAuth } from "../../redux/slice/authSlice";
import { updateLocationTagApi } from "../../api/adminApi/adminApi";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

// function getComparator(order, orderBy) {
//   return order === "desc"
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy);
// }

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

// const headCells = [
//   {
//     id: "organizationName",
//     numeric: true,
//     disablePadding: true,
//     label: "Practice Name",
//   },
//   // {
//   //   id: "organizationType",
//   //   numeric: true,
//   //   disablePadding: false,
//   //   label: "Organization Type",
//   // },
//   {
//     id: "email",
//     numeric: true,
//     disablePadding: false,
//     label: "BVDQ Receiver Email",
//   },
//    {
//     id: "doctor",
//     numeric: true,
//     disablePadding: false,
//     label: "Doctor Name",
//   },
//   {
//     id: "status",
//     numeric: true,
//     disablePadding: false,
//     label: "Status",
//   },
//   {
//     id: "actions",
//     numeric: true,
//     disablePadding: false,
//     label: "Actions",
//   },
// ];

const headCells = [
  {
    id: "organizationName",
    numeric: true,
    disablePadding: true,
    label: "Practice Name",
  },
  {
    id: "email",
    numeric: true,
    disablePadding: false,
    label: "BVDQ Receiver Email",
  },
  { id: "doctor", numeric: true, disablePadding: false, label: "Doctor Name" },
  {
    id: "location_id",
    numeric: true,
    disablePadding: false,
    label: "Location ID",
  },
  { id: "status", numeric: true, disablePadding: false, label: "Status" },
  { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return <></>;
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export const ProviderTable = ({ search }) => {
  const toastOptions = useToast();
  const headers = useHeaders();
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("desc");
  const [openWebHook, setOpenWebHook] = useState(false);
  const [loading, setLoading] = useOutletContext();
  const [orderBy, setOrderBy] = React.useState("created_at");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rows, setRows] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const { encryptData, decryptData } = useEncryption();
  const [totalTeams, setTotalTeams] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const userData = useSelector(selectAuth);
  const [webhookURl, setUrl] = useState("");

  const [openTagModal, setOpenTagModal] = useState(false);
  const [selectedLocationRow, setSelectedLocationRow] = useState(null);

  const handleOpenLocationTag = (row) => {
    setSelectedLocationRow(row);
    setOpenTagModal(true);
  };

  const handleCloseLocationTag = () => {
    setOpenTagModal(false);
    setSelectedLocationRow(null);
  };



  const dispatch = useDispatch();
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows = rows?.length == 0;

  useEffect(() => {
    const getUrl = async () => {
      let response = await getWebhookUrl(userData.id);
      setUrl(response.data.data.url);
    };
    getUrl();
    fetchData();
  }, [page, rowsPerPage, order, orderBy, search]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getProvidersApi(
        page,
        rowsPerPage,
        orderBy,
        order,
        search
      );

      const decryptedData = decryptData(response?.data?.data);
      setRows(decryptedData?.providers);
      setTotalTeams(decryptedData?.totalProviders);
      setTotalPages(decryptedData?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const onSaveLocationTag = async (providerId, tag) => {
    try {
      const encrypted = encryptData({ locationTag: tag });    
      const response = await updateLocationTagApi(providerId, { data: encrypted });
      toast.success( response?.data?.message || "Location Tag updated successfully");
      handleCloseLocationTag();
      fetchData();
    } catch (err) {
      toast.error(err?.message || "Failed to update");
    }
  };

  const handleView = (row) => {
    dispatch(
      setLocationData({
        organization_name: row?.organizationName,
        // organization_type: row?.organizationType,
        email: row?.email,
        status: row?.status,
      })
    );
    navigate(`/admin/dashboard/provider/${row?.id}`);
  };

  const resendEmail = async (id, email) => {
    try {
      const modifiedValues = {
        id,
        email,
      };
      const data = encryptData(modifiedValues);
      const response = await resendInviteProviderApi(data, headers);
      toast.success(response.data.message, toastOptions);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message, toastOptions);
    }
  };

  const handleClickWebHookClose = () => {
    setSelectedProvider(null);
    setOpenWebHook(false);
  };

  const handleClickOpenWebHook = (provider) => {
    setSelectedProvider(provider);
    setOpenWebHook(true);
  };

  return (
    <div className="tableDesigned">
      <Box>
        <Paper>
          <EnhancedTableToolbar numSelected={selected.length} />
          <TableContainer>
            <Table>
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={totalTeams}
              />
              <TableBody>
                {rows?.map((row, index) => {
                  const isItemSelected = isSelected(row?.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row?.id}
                      selected={isItemSelected}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          onClick={(event) => handleClick(event, row?.id)}
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                        onClick={() => handleView(row)}
                      >
                        {/* <div className="d-flex align-items-center">
                          {row?.organizationName}
                        </div> */}
                        <div className="d-flex align-items-center">
                          {row?.firstName
                            ? row.firstName
                            : row?.organizationName}
                        </div>
                        {/* <TableCell onClick={() => handleView(row)}>
                          {row?.doctor || ""}
                        </TableCell> */}
                      </TableCell>
                      {/* <TableCell onClick={() => handleView(row)}>{row?.organizationType}</TableCell> */}
                      <TableCell onClick={() => handleView(row)}>
                        {row?.email}
                      </TableCell>
                      <TableCell onClick={() => handleView(row)}>
                        {row?.primaryDoctor
                          ? `Dr. ${row?.primaryDoctor?.firstName || ""} ${
                              row?.primaryDoctor?.lastName || ""
                            }`
                          : "--"}
                      </TableCell>
                      <TableCell onClick={() => handleView(row)}>
                        {row?.location_id}
                      </TableCell>

                      <TableCell onClick={() => handleView(row)}>
                        {row?.status}
                      </TableCell>

                      <TableCell>
                        <div className="btn-groups">
                          <Tooltip title="View" arrow>
                            <button
                              className="actionbuttons"
                              onClick={() => handleView(row)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M20.4908 11.1432C20.8361 11.6696 20.8361 12.3304 20.4908 12.8568C19.4032 14.5146 16.5729 18 11.9999 18C7.4269 18 4.5966 14.5146 3.50898 12.8568C3.16367 12.3304 3.16367 11.6696 3.50898 11.1432C4.5966 9.48535 7.4269 6 11.9999 6C16.5729 6 19.4032 9.48535 20.4908 11.1432Z"
                                  stroke="#35353A"
                                  strokeWidth="1.25"
                                  strokeLinecap="round"
                                />
                                <path
                                  d="M15 12C15 13.6569 13.6568 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6568 9 15 10.3431 15 12Z"
                                  stroke="#35353A"
                                  strokeWidth="1.25"
                                  strokeLinecap="round"
                                />
                              </svg>
                            </button>
                          </Tooltip>
                          {/* <button
                            className="actionbuttons"
                            onClick={() => resendEmail(row?.id, row?.email)}
                          >
                            <svg
                              width="24"
                              height="25"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.98242 6.35107L11.09 10.9633L11.0921 10.965C11.7702 11.4623 12.1095 11.7111 12.4812 11.8072C12.8096 11.8922 13.1549 11.8922 13.4834 11.8072C13.8553 11.711 14.1956 11.4615 14.875 10.9633C14.875 10.9633 18.7925 7.95701 20.9824 6.35107M3.98242 16.1512V8.55127C3.98242 7.43116 3.98242 6.87069 4.20041 6.44287C4.39215 6.06654 4.69789 5.7608 5.07422 5.56906C5.50204 5.35107 6.06251 5.35107 7.18262 5.35107H18.7826C19.9027 5.35107 20.462 5.35107 20.8898 5.56906C21.2661 5.7608 21.5729 6.06654 21.7646 6.44287C21.9824 6.87027 21.9824 7.43006 21.9824 8.54798V16.1546C21.9824 17.2725 21.9824 17.8315 21.7646 18.2589C21.5729 18.6352 21.2661 18.9415 20.8898 19.1332C20.4624 19.351 19.9034 19.351 18.7855 19.351H7.17933C6.06141 19.351 5.50162 19.351 5.07422 19.1332C4.69789 18.9415 4.39215 18.6352 4.20041 18.2589C3.98242 17.8311 3.98242 17.2713 3.98242 16.1512Z"
                                stroke="#241C1E"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </button> */}
                          <Tooltip title="Link" arrow>
                            <button
                              className="actionbuttons"
                              onClick={() => handleClickOpenWebHook(row)}
                            >
                              <svg
                                width="19"
                                height="19"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15.197 3.35462C16.8703 1.67483 19.4476 1.53865 20.9536 3.05046C22.4596 4.56228 22.3239 7.14956 20.6506 8.82935L18.2268 11.2626M10.0464 14C8.54044 12.4882 8.67609 9.90087 10.3494 8.22108L12.5 6.06212"
                                  stroke="#35353A"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                />
                                <path
                                  d="M13.9536 10C15.4596 11.5118 15.3239 14.0991 13.6506 15.7789L11.2268 18.2121L8.80299 20.6454C7.12969 22.3252 4.55237 22.4613 3.0464 20.9495C1.54043 19.4377 1.67609 16.8504 3.34939 15.1706L5.77323 12.7373"
                                  stroke="#35353A"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                />
                              </svg>
                            </button>
                          </Tooltip>
                          <Tooltip title="Location Tag" arrow>
                            <button
                              className="actionbuttons"
                              onClick={() => handleOpenLocationTag(row)}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 21C12 21 20 14.9 20 10C20 6.13401 16.866 3 13 3C9.13401 3 6 6.13401 6 10C6 14.9 12 21 12 21Z"
                                  stroke="#35353A"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                />
                                <path
                                  d="M12 12.5C13.3807 12.5 14.5 11.3807 14.5 10C14.5 8.61929 13.3807 7.5 12 7.5C10.6193 7.5 9.5 8.61929 9.5 10C9.5 11.3807 10.6193 12.5 12 12.5Z"
                                  stroke="#35353A"
                                  strokeWidth="1.5"
                                />
                                <path
                                  d="M12 7V3"
                                  stroke="#35353A"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                />
                              </svg>
                            </button>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={8} className="norecord">
                      No Record Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100]}
            component="div"
            count={totalTeams}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
      <WebHookModal
        openWebHook={openWebHook}
        handleClose={handleClickWebHookClose}
        provider={selectedProvider}
        webhookUrl={webhookURl}
      />
      <LocationTagModal
        open={openTagModal}
        handleClose={handleCloseLocationTag}
        provider={selectedLocationRow}
        onSave={onSaveLocationTag}
      />
    </div>
  );
};


